import api from '../util/instance';
import { urls } from './Api';

export const sendInviteAnalyst = async (userId) => {
    // test
    await api.post(`${urls.AnalystInvite}/${userId}`);
};

export const churnRate = async () => await api.get(urls.churnRate);
